//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/solucoes/:solution',
      en: '/solutions/:solution',
      es: '/soluciones/:solution'
    }
  },

  async asyncData({ $api, params, $helpers }) {
    try {
      // Get solution details
      const { solution: slug } = params
      const { data } = await $api.solutions.show(slug)
      const { solutions: solution, applications } = data

      // Get all solutions
      const { data: solutionsItems } = await $api.solutions.showAll()
      const solutions = solutionsItems.map((item) => {
        return {
          label: item.title,
          url: `/solucoes/${item.slug}`
        }
      })

      // Handle with the medias
      if (solution.video) {
        const video = {
          url: $helpers.getYTThumbnail(solution.video),
          video_url: solution.video,
          type: 'video',
          custom: {}
        }

        solution.medias = [video, ...solution.medias]
      }

      return {
        solution,
        solutions,
        applications
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      solution: {},
      solutions: [],
      applications: []
    }
  },

  head() {
    const { title, seo, main_image } = this.solution

    return this.$helpers.seoBuilder(this, {
      staticTitle: seo ? seo.title : title || this.$t('title'),
      staticDescription: seo ? seo.description : null,
      ogImage: main_image ? main_image.url : null,
      ogImageWidth: main_image ? 360 : null,
      ogImageHeight: main_image ? 389 : null
    })
  },

  computed: {
    breadcrumbs() {
      return [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/solucoes'
        },
        {
          name: this.solution.title,
          path: this.$route.fullPath
        }
      ]
    }
  }
}
